import { MoipValidator } from 'moip-sdk-js'
import { BaseServices } from './BaseServices';

export class MoipServices extends BaseServices {
    getCardBrand (cardNumber) {
        var cardBrand = MoipValidator.cardType(cardNumber)
        if (cardBrand)
            return cardBrand.brand
        return ""
    }

    validateNumber (cardNumber) {
        return MoipValidator.isValidNumber(cardNumber)
    }

    validateExpirationDate (month, year) {
        return MoipValidator.isExpiryDateValid(month, year)
    }

    validateSecurityCode (cardNumber, securityCode) {
        return MoipValidator.isSecurityCodeValid(cardNumber, securityCode)
    }
}
